import { toast } from '@qodo/design-system';
import { useMutation } from '@tanstack/react-query';
import { spawn } from '../../utils/translations';
import { RepositoryClient } from '../httpClients/RepositoryClient';
import { MUTATION_KEYS } from './consts';
import { getErrorToastContent } from './utils';

/**
 * Mutation hook to initiate GitHub installation for MT accounts.
 * Calls the backend to generate a GitHub installation URL with server-managed state.
 */
export const useInitiateMTGithubInstallationMutation = () => {
  const spawnErrors = spawn('dialogs.github-mt-installation.errors');

  return useMutation({
    mutationKey: [MUTATION_KEYS.INITIATE_MT_GITHUB_INSTALLATION],
    mutationFn: async ({
      frontendRedirectUrl,
    }: {
      frontendRedirectUrl: string;
    }) => {
      return await RepositoryClient.initiateMTGithubInstallation(
        frontendRedirectUrl,
      );
    },
    onError: (err: unknown) => {
      const errorFromServer = getErrorToastContent(err, spawnErrors('generic'));

      toast.error(errorFromServer);
    },
  });
};
